export default defineNuxtPlugin((nuxtApp) => {
  if (!process.client) return

  const consentStore = useConsentStore()
  const config = useRuntimeConfig()
  const gaId = config.public?.gaId || config.public?.gaMeasurementId
  let gaLoaded = false

  const ensureGtag = () => {
    window.dataLayer = window.dataLayer || []
    window.gtag =
      window.gtag ||
      function gtag() {
        window.dataLayer.push(arguments)
      }
  }

  const updateGtagConsent = (analyticsAllowed) => {
    ensureGtag()
    window.gtag('consent', 'update', {
      analytics_storage: analyticsAllowed ? 'granted' : 'denied',
      ad_storage: 'denied',
      functionality_storage: 'granted',
      security_storage: 'granted'
    })
  }

  const loadGa = () => {
    if (gaLoaded || !gaId) return
    ensureGtag()

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`
    document.head.appendChild(script)

    window.gtag('js', new Date())
    window.gtag('config', gaId, { anonymize_ip: true })
    gaLoaded = true
  }

  const clearGaCookies = () => {
    const domain = window.location.hostname
    const domainParts = domain.split('.')
    const rootDomain = domainParts.slice(-2).join('.')
    const allCookies = document.cookie.split(';').map(c => c.trim().split('=')[0])
    
    // Find all GA-related cookies (includes _ga, _gid, _gat, _ga_*, etc.)
    const gaCookies = allCookies.filter(name => 
      name.startsWith('_ga') || name.startsWith('_gid') || name.startsWith('_gat')
    )
    
    gaCookies.forEach((name) => {
      const deletionPatterns = [
        `${name}=; Max-Age=0; path=/; domain=${domain}`,
        `${name}=; Max-Age=0; path=/; domain=.${domain}`,
        `${name}=; Max-Age=0; path=/; domain=${rootDomain}`,
        `${name}=; Max-Age=0; path=/; domain=.${rootDomain}`,
        `${name}=; Max-Age=0; path=/`
      ]
      
      deletionPatterns.forEach(pattern => {
        document.cookie = pattern
      })
    })
  }

  nuxtApp.hook('app:mounted', () => {
    consentStore.initialize()
    const analyticsAllowed = !!consentStore.analyticsAllowed
    updateGtagConsent(analyticsAllowed)
    
    if (analyticsAllowed) {
      loadGa()
    } else {
      clearGaCookies()
    }
  })

  watch(
    () => consentStore.analyticsAllowed,
    (allowed) => {
      updateGtagConsent(allowed)
      if (allowed) {
        loadGa()
      } else {
        clearGaCookies()
      }
    }
  )
})
